import { useCurrentUser, useFeatureFlag } from '../../../../hooks';
import { useQResourceContext } from '../../../../QLayouts/QResourceRoutes/context';
import { useQuery } from 'react-query';
import { Task, TaskStatus } from './types';

type RetrieveTasks = {
  isLoading: boolean;
  total: number;
  tasks: readonly Task[];
};

export const useRetrieveTasks = (enabled = true): RetrieveTasks => {
  const { mtbeClient, qri } = useQResourceContext();
  const { companyId } = useCurrentUser();
  const showTasksEverywhere = Boolean(useFeatureFlag()['tasks-everywhere']);

  const data = useQuery({
    queryKey: ['RetrieveTasks', companyId, qri],
    queryFn: () =>
      mtbeClient.post<Task[]>(`/v3/${companyId}/usertasks_by_qris`, {
        qris: qri,
      }),
    enabled: showTasksEverywhere && enabled && qri.length > 0,
  });

  return {
    isLoading: data.isLoading,
    total:
      data.data?.data.filter((item) => item.status === TaskStatus.OPEN)
        .length ?? 0,
    tasks: data.data?.data ?? [],
  };
};
